import React, { useEffect, useState } from "react";
import PrivateApi from "../../../services/PrivateApiService";
import { Button, Col, Form, InputGroup, Row, Spinner } from "react-bootstrap";
import { FaAddressBook, FaUser } from "react-icons/fa";
import DataTable from "react-data-table-component";
import { useAuthDispatch, useAuthState } from "../../../context/AuthContext";


/**
 * 
 * User ticket stage component
 * 
 * @param {state} props list of last data collecting of backend to avoid multiple collection of same data
 * @param {setState} props sets by data collection from backend
 * @param {user} props object logged user
 * @param {selectedUser} props object
 * @param {setSelectedUser} props setter object
 * @param {error} props setter api error
 * 
 * @returns 
 */
const UserTicketStage = (props) => {

    const API = new PrivateApi();
    const { contactPerson } = useAuthState();
    const dispatch = useAuthDispatch();
    const [usersLoading, setUsersLoading] = useState(false);
    const [users, setUsers] = useState(props.state);
    const [selectedUser, setSelectedUser] = useState(null);
    const [filteredUsers, setFilteredUsers] = useState(props.state);
    const [newContact, setNewContact] = useState(false);
    const [newContactSaving, setNewContactSaving] = useState(false);

    // * fields
    const [contactName, setContactName] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [contactPhone, setContactPhone] = useState("");
    const [fieldError, setFieldError] = useState("");
    const [filterUserField, setFilterUserField] = useState("");
    const userColumns = [
        { name: 'Name', selector: row => row.name, sortable: true },
        { email: "E-Mail", selector: row => row.email, sortable: true }
    ]
    const [validated, setValidated] = useState(false);

    const paginationOptions = {
        rowsPerPageText: 'Zeilen pro Seite',
        rangeSeparatorText: 'von',
        selectAllRowsItemText: 'Alle'
    }


    // geather users from backend
    useEffect(() => {
        props.setSelectedUser(null);
        setFilteredUsers(users);
        setFilterUserField("");

        if (contactPerson) {
            setSelectedUser(contactPerson);
            props.setSelectedUser(contactPerson);
            props.setStage('summarize')
        }

        if (users === undefined || users.length === 0) {
            setUsersLoading(true);
            API.get_Partner_employees()
                .then(res => {
                    let data = res.data;
                    setUsers(data);
                    setFilteredUsers(data);
                    props.setState(data);
                    setUsersLoading(false);
                })
                .catch(err => {
                    if (err.response.data.detail !== undefined) {
                        props.error(err.response.data.detail);
                        return props.setStage('error');
                    }
                    props.error("Unbekannter Fehler.");
                    return props.setStage('error');
                })
        }
    }, []);


    useEffect(() => {
        if (filterUserField.length > 1) {
            var tempList = [];
            tempList = users.filter(u => u.name.toUpperCase().includes(filterUserField.toUpperCase()) || u.email.toUpperCase().includes(filterUserField.toUpperCase()));
            return setFilteredUsers(tempList);
        }
        setFilteredUsers(users);
    }, [filterUserField])


    // * handlers
    const saveNewContact = () => {
        setNewContactSaving(true);
        setFieldError("");

        if (contactName === "" || !contactName.includes(" ") || contactName.length < 5) {
            setNewContactSaving(false);
            return setFieldError("Name und Nachname mussen eingegeben werden.");
        }
        if (contactEmail === "" || contactEmail.length < 5) {
            setNewContactSaving(false);
            return setFieldError("E-Mail-Adresse muss eingegeben werden.");
        }
        if (contactEmail.includes("@")) {
            setNewContactSaving(false);
            return setFieldError(`Bitte geben Sie lediglich den Teil Ihrer E-Mail-Adresse vor dem Zeichen @ an. @${props.user.email.split('@')[1]} wird automatisch hinzugefügt.`);
        }

        var fullEmail = `${contactEmail}@${props.user.email.split('@')[1]}`;
        var data = { name: contactName, email: fullEmail, phone: contactPhone };
        API.post_Partner_employee_save(data)
            .then(res => {
                let data = res.data;
                var tempList = [data, ...users];
                setUsers(tempList);
                setFilteredUsers(tempList);
                setNewContactSaving(false);
                setContactName("");
                setContactEmail("");
                setContactPhone("");
                setNewContact(false);
                setTimeout(() => {
                    var tableRow = document.getElementById(`row-${data.id}`);
                    tableRow.classList.add('animate-slide-left');
                }, 500);
            })
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    props.error(err.response.data.detail);
                } else {
                    props.error("Unbekannter Fehler.")
                }
                setNewContactSaving(false);
                props.setStage("error");
            })
    }

    // style datatable on select
    const conditionalRowStyles = [
        {
            when: row => row === selectedUser,
            style: {
                background: '#a2c13f',
                userSelect: "none",
            }
        }
    ]


    // select user table handler
    const selectRowHandler = (row) => {
        if (selectedUser === row) {
            setSelectedUser(null);
            dispatch('CLEAR_CONTACT');
        }
        else {
            setSelectedUser(row);
            dispatch('POPULATE_CONTACT', row);
        }
    }

    return (
        <>
            {usersLoading ?
                <>
                    <Row className="mt-5 text-center">
                        <p>{props.user.name} Benutzer werden gesammelt...</p>
                        <Col xs="12">
                            <Spinner className="text-energo" animation="grow" /> &nbsp;
                            <Spinner className="text-energo" animation="grow" /> &nbsp;
                            <Spinner className="text-energo" animation="grow" />
                        </Col>
                    </Row>
                </>
                :
                <>
                    <h5>Bitte wählen Sie Ihre Kontaktinformation aus</h5>
                    <Row className="mt-5" hidden={selectedUser === null}>
                        <Col xs="12" className="text-center">
                            <div className="circle-icon">
                                <FaUser className="text-energo" size={100} />
                            </div>
                            <br />
                            {selectedUser !== null ?
                                <>
                                    <b>{selectedUser.name}</b> <br />
                                    <small className="text-muted">{selectedUser.email}</small>
                                </>
                                : null}
                        </Col>
                    </Row>
                    <Row hidden={!newContact} className="mt-5" style={{ border: "1px solid #ccc", borderRadius: "10px", padding: "10px" }}>
                        <p className="text-energo">Neuer Kontakt erstellen</p>
                        <small className="text-muted">Bitte geben Sie Ihre Kontaktdaten an</small>
                        <Col xs="12">
                            <Form.Control
                                onChange={e => setContactName(e.target.value)}
                                value={contactName}
                                disabled={newContactSaving}
                                placeholder="Name und Nachname *"
                            />
                        </Col>
                        <Col xs="12" className="mt-3">
                            <InputGroup>
                                <Form.Control
                                    onChange={e => setContactEmail(e.target.value)}
                                    value={contactEmail}
                                    disabled={newContactSaving}
                                    placeholder="E-Mail-Adresse *"
                                />
                                <InputGroup.Text>@{props.user.email.split('@')[1]}</InputGroup.Text>
                            </InputGroup>
                        </Col>
                        <Col xs="12" xl="8" className="mt-3">
                            <Form.Control
                                onChange={e => setContactPhone(e.target.value)}
                                value={contactPhone}
                                disabled={newContactSaving}
                                placeholder="Telefonnummer"
                            />
                        </Col>
                        <Col xs="12" xl="6">
                            <small hidden={fieldError === ""} className="text-danger">{fieldError}</small>
                        </Col>
                        <Col hidden={newContactSaving} xs="12" xl="6" className="text-end mt-3">
                            <Button
                                onClick={() => setNewContact(false)}
                                variant="warning"
                                style={{ marginRight: "5px" }}
                            >Abrechen
                            </Button>
                            <Button
                                onClick={() => saveNewContact()}
                                className="btn-energo"
                            >Speichern
                            </Button>
                        </Col>
                        <Col hidden={!newContactSaving} xs="12" className="text-end mt-3">
                            <Spinner animation="border" className="text-energo" />
                        </Col>
                    </Row>
                    <Row className="mt-5 align-items-center">
                        <Col xs="12" md="7" xl="9">
                            <Form.Control
                                onChange={e => setFilterUserField(e.target.value)}
                                value={filterUserField}
                                placeholder="Name, Nachname, E-Mail-Adresse"
                            />
                        </Col>
                        <Col xs="12" md="5" xl="3" className="text-end">
                            <Button onClick={() => setNewContact(true)}><FaAddressBook /> Neuer Kontakt</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <DataTable
                                data={filteredUsers}
                                columns={userColumns}
                                onRowClicked={row => selectRowHandler(row)}
                                conditionalRowStyles={conditionalRowStyles}
                                paginationComponentOptions={paginationOptions}
                                pagination
                            />
                        </Col>
                    </Row>
                    <Row className="mt-5">
                        <Col xs="12" className="text-end">
                            <Button
                                onClick={() => props.setStage('body')}
                                variant="warning"
                                style={{ marginRight: "5px" }}>Zurück
                            </Button>
                            <Button
                                onClick={() => { props.setSelectedUser(selectedUser); props.setStage('summarize') }}
                                className="btn-energo"
                                hidden={selectedUser === null}
                            >Weiter
                            </Button>
                        </Col>
                    </Row>
                </>
            }
        </>
    )
}

export default UserTicketStage;